import React, { Component } from "react";
import Filters from "./Filters";
import DeckDetails from "./DeckDetails";

class DeckBuilderMain extends Component {

  render() {
    var mainStyle = {
      width: this.props.width,
      color: "white",
      paddingTop: "50px"
    };

    var displayPanel;
    if (this.props.saveform) {
      displayPanel = <DeckDetails deckSave={this.props.deckSave} deckNameHandler={this.props.deckNameHandler} authorHandler={this.props.authorHandler} descriptionHandler={this.props.descriptionHandler}
      author={this.props.author} description={this.props.description} deckName={this.props.deckName} />;
    } else {
      displayPanel = <Filters clickHandler={this.props.clickHandler} width={this.props.width} />;
    }

    return (
        <main style={mainStyle} className="Site_Content">
          {displayPanel}
        </main>
    );
  }
}

export default DeckBuilderMain;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/DeckBuilderMain.js